import React, { createContext, useContext, useState, useEffect } from 'react';

const AppContext = createContext();

export const AppProvider = ({ children }) => {
  // Recupera os dados do localStorage (se existirem) ao inicializar o estado
  const [companies, setCompanies] = useState(() => {
    const storedCompanies = localStorage.getItem('companies');
    return storedCompanies ? JSON.parse(storedCompanies) : [];
  });

  const [accessKey, setAccessKey] = useState(() => {
    return localStorage.getItem('accessKey') || '';
  });

  const [selectedCompany, setSelectedCompany] = useState(() => {
    return localStorage.getItem('selectedCompany') ? parseInt(localStorage.getItem('selectedCompany')) : 0;
  });

  const [codassinante, setCodAssinante] = useState(() => {
    return localStorage.getItem('codassinante') ? parseInt(localStorage.getItem('codassinante')) : 0;
  });

  // Atualiza o estado e armazena os dados no localStorage ao fazer login
  const updateLoginData = (data, key) => {
    setCompanies(data);
    setAccessKey(key);
    localStorage.setItem('companies', JSON.stringify(data));
    localStorage.setItem('accessKey', key);
  };

  // Atualiza o localStorage sempre que selectedCompany ou codassinante forem alterados
  useEffect(() => {
    localStorage.setItem('selectedCompany', selectedCompany);
  }, [selectedCompany]);

  useEffect(() => {
    localStorage.setItem('codassinante', codassinante);
  }, [codassinante]);

  //console.log("CodEmpresa no Contexto:", selectedCompany);
  //console.log("CodAssinante no Contexto:", codassinante);

  return (
    <AppContext.Provider
      value={{
        companies,
        accessKey,
        selectedCompany,
        codassinante,
        setSelectedCompany,
        setCodAssinante,
        updateLoginData,
      }}
    >
      {children}
    </AppContext.Provider>
  );
};

export const useAppContext = () => useContext(AppContext);
